import React from 'react'
import {wrapLazy} from '@startlibs/utils'
import {jwtGetFetcher} from '../../utils/authFetch'


// export const hasAcceptedAllTerms = (terms,caseRequest) => terms.length && !terms.find(({id}) => !caseRequest.acceptanceInfo?.agreements?.find(({serviceTermId}) => serviceTermId === id))

// NEW
export const hasAcceptedAllTerms = (terms, caseRequest) => {
  // All acceptance records
  const { agreements = [] } = caseRequest.acceptanceInfo || {};
  
  // Get unique languages from user's signed agreements
  const signedLanguages = [
    ...new Set(agreements.map(a => a.serviceTermsDetails?.language)),
  ].filter(Boolean); // filter out undefined just in case

  // If user didn’t sign anything, return false
  if (!signedLanguages.length) return false;

  // For each signed language, check if all terms in that language are covered
  return signedLanguages.some(signedLang => {
    // Filter the global terms to those in this language
    const termsInLang = terms.filter(t => t.language === signedLang);
    
    // If there are no terms for that language, skip
    if (!termsInLang.length) return false;
    
    // Verify user has an agreement for each term in this language
    const hasAllForThisLang = termsInLang.every(term => {
      return agreements.some(a => {
        return (
          a.serviceTermId === term.id &&
          a.serviceTermsDetails?.language === signedLang
        );
      });
    });

    return hasAllForThisLang;
  });
};

export const lazyTerms = wrapLazy((jwt) =>
  jwtGetFetcher(jwt)('/api/serviceTerms')
)

export const isReadOnlyShare = (caseRequest) => caseRequest?.requestCode?.indexOf("RO-")===0